import httpClient from '@/libs/http-client'

export function apiIsOtpLogin(params) {
  const url = '/api/common/isOtpLogin'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}


export function apiMakeSiteOtp(params) {
  const url = '/api/super/makeSiteOtp'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function apiUpdateOtpUseYn(params) {
  const url = '/api/super/updateOtpUseYN'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

